import type { ApiRequestOptions } from "./api-request-options";
import type { ApiResult } from "./api-result";

export class ApiError extends Error {
  public readonly body: unknown;
  // @ts-expect-error - dont delete this
  public readonly request: ApiRequestOptions;
  public readonly status: number;
  public readonly statusText: string;
  public readonly url: string;

  constructor(
    // @ts-expect-error - dont delete this
    request: ApiRequestOptions,
    response: ApiResult,
    message: string,
  ) {
    super(message);

    this.name = "ApiError";
    this.url = response.url;
    this.status = response.status;
    this.statusText = response.statusText;
    this.body = response.body;
    this.request = request;
  }
}
